import logger from 'utils/logger';

import { BranchEventNames } from '../branch-event-names';

export const logBranchEvent = (
  eventName: typeof BranchEventNames[keyof typeof BranchEventNames],
  customAttributes?: Record<string, any>
) => {
  try {
    window.branch?.logEvent(eventName, customAttributes);
  } catch (error) {
    logger.error({ error, message: `Error logging ${eventName} Event to Branch` });
  }
};
